module.exports = __webpack_public_path__ + "statics/img/gqsh.jpg";